import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function EmotionalHook() {
  return <section className="pt-8 pb-6 px-4 bg-gradient-to-b from-[#FFF5F7] to-[#FEF0F3]" data-id="element-105">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-106">
        <FadeIn data-id="element-107">
          <p className="text-2xl md:text-3xl font-serif leading-relaxed text-[#4a2535] text-center italic opacity-90" data-id="element-108">
            "Hay un momento —muy silencioso— en el que dejás de discutir para
            resolver… y empezás a discutir para defenderte."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-109">
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-[#7a5568]" data-id="element-110">
            <p data-id="element-111">No pasa de golpe. No hay un día exacto.</p>
            <p data-id="element-112">Solo aparece el cansancio.</p>
            <p data-id="element-113">
              Cansancio de explicar. De repetir. De volver a hablar de lo mismo
              esperando que, esta vez, algo cambie.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-114">
          <div className="bg-white p-8 rounded-2xl border border-[#f0d0dc] shadow-[0_8px_32px_rgba(196,96,122,0.08)] my-4" data-id="element-115">
            <p className="text-xl text-[#c4607a] mb-4 font-serif" data-id="element-116">
              Y cuando no cambia, aparece la pregunta que más duele:
            </p>
            <h3 className="text-3xl md:text-4xl font-serif text-[#2d1520] mb-6" data-id="element-117">
              "¿Qué estoy haciendo mal?"
            </h3>
            <p className="text-lg text-[#7a5568] mb-4" data-id="element-118">
              La respuesta es incómoda… pero profundamente liberadora.
            </p>

            <div className="flex items-start gap-4 mt-8" data-id="element-119">
              <div data-id="element-120">
                <span className="text-3xl font-bold text-[#c4607a] block mb-2" data-id="element-121">
                  Nada.
                </span>
                <p className="text-xl text-[#2d1520]" data-id="element-122">
                  No estás fallando. No sos exagerada. No sos "difícil".
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-123">
          <p className="text-2xl md:text-3xl text-center font-serif text-[#4a2535] leading-relaxed border-t border-b border-[#f0d0dc] py-6" data-id="element-124">
            Lo estás haciendo bien. Solo estás atrapada en un ciclo emocional
            que nadie te enseñó a romper.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-125">
          <div className="flex justify-center mt-2" data-id="element-126">
            <a href="#precio" onClick={e => {
            e.preventDefault();
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="group bg-[#c4607a] hover:bg-[#b35068] text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-[0_4px_24px_rgba(196,96,122,0.25)] hover:shadow-[0_6px_32px_rgba(196,96,122,0.4)] flex items-center gap-2 no-underline" data-id="element-127">
              Quiero mi guía
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-128" />
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}